<template functional>
  <button
    class="btn"
    :class="props.buttonClass"
    :style="props.buttonStyle"
    :type="props.type"
    v-on="listeners"
    :disabled="props.loading || props.disabled"
  >
    <slot></slot>
    <span
      v-if="props.loading && props.labelOnLoading && props.disabled !== true"
    >{{props.labelOnLoading}}</span>
    <span v-if="!props.loading && props.label || props.disabled === true">{{props.label}}</span>
  </button>
</template>

<script>
export default {
  props: {
    buttonClass: { type: String, default: 'btn-primary' },
    buttonStyle: { type: Object },
    type: { type: String, default: 'button' },
    label: { type: String, default: '' },
    labelOnLoading: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    listeners: { type: Function, default: () => {} },
    disabled: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';
@import '~bootstrap/scss/buttons';

.btn-overlay {
  background: $gray-200;
  color: $gray-800;
  bottom: 0;
  width: 100%;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  border: 0;
  border-radius: 0;
}

.btn-overlay:hover {
  color: $gray-800;
}

.btn-overlay:focus {
  outline: none !important;
}

@media (min-width: 320px) and (max-width: 767.98px) {
  .btn-overlay {
    bottom: 0;
    width: 100%;
    margin-bottom: $spacer;
  }
}

@media (max-width: 991.98px) {
  .disabled-pl {
    padding-left: 0;
  }
}
</style>
